import React, { useState } from 'react';
import YouTube from 'react-youtube';
import Img from '../../Img';
import LinkAnchor from '../../Links/LinkAnchor';
import Popup from '../../Popup';

import styles from './tiles.module.scss';
import PtsWidget from '../PtsWidget';
// updated for prismic

const TiledSection = (props) => {
    const [popup, displayPopup] = useState(false);
    const { section } = props;
    const desktopBg = section.sectionimage && section.sectionimage.desktop;
    const mobileBg = section.sectionimage && section.sectionimage.mobile;
    const videoId = section.sectionvideo ? section.sectionvideo.split('v=')[1] : null;
    const bgImg = (imageObj) => {
        if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
            return (
                <Img
                    useRawSrcSet={true}
                    src={imageObj.oneX}
                    srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                    style={{ left: '0%' }}
                />
            );
        } if (imageObj && imageObj.default) {
            return (
                <Img
                    src={imageObj.default}
                    style={{ left: '0%' }}
                />
            );
        }
        return null;
    };

    const videoOpts = {
        width: '576',
    };
    const mobileVideoOpts = {
        width: '100%',
    };

    return (
        <div className={`${styles.section}`}>
            <div className={`container ${styles.container}`}>
                <div className="row">
                    <div className={`col-12 col-md-6 ${styles.content} ${section.imageposition === 'right' ? 'order-1' : 'order-2'}`}>
                        <h3 className={`${styles.title} mt16`}>
                            <div>{section.title}</div>
                        </h3>
                        <p dangerouslySetInnerHTML={{ __html: section.description }} />
                        <div>
                            {section.primaryctacopy && section.primaryctalink && (
                                <LinkAnchor
                                    href={section.primaryctalink}
                                >
                                    <div className={`btn btn-primary btn-lg text-white ${styles.joinBtn} mr16 mb16 text-uppercase d-none d-sm-inline-block`}>
                                        {section.primaryctacopy}
                                    </div>
                                    <div className={`btn btn-primary btn-sm text-white ${styles.joinBtn} mr16 mb16 text-uppercase d-inline-block d-sm-none`}>
                                        {section.primaryctacopy}
                                    </div>
                                </LinkAnchor>
                            )}
                            {section.secondaryctacopy && section.secondaryctalink && !section.secondaryctalink.includes('crionet-ms-widgets') && (
                                <LinkAnchor
                                    href={section.secondaryctalink}
                                >
                                    <div className={`btn btn-default btn-lg ${styles.joinBtn} mb16 text-uppercase d-none d-sm-inline-block`}>
                                        {section.secondaryctacopy}
                                    </div>
                                    <div className={`btn btn-default btn-sm ${styles.joinBtn} mb16 text-uppercase d-inline-block d-sm-none`}>
                                        {section.secondaryctacopy}
                                    </div>
                                </LinkAnchor>
                            )}
                            {section.secondaryctacopy && section.secondaryctalink && section.secondaryctalink.includes('crionet-ms-widgets') && (
                                <React.Fragment>
                                    <div onClick={() => displayPopup(true)} className={`btn btn-default btn-lg ${styles.joinBtn} mb16 text-uppercase d-none d-sm-inline-block`}>
                                        {section.secondaryctacopy}
                                    </div>
                                    <div onClick={() => displayPopup(true)} className={`btn btn-default btn-sm ${styles.joinBtn} mb16 text-uppercase d-inline-block d-sm-none`}>
                                        {section.secondaryctacopy}
                                    </div>
                                    {popup && (
                                        <Popup
                                            className={`popup-md`}
                                            popUpClassName={`${styles.popup}`}
                                            onCloseClick={() => displayPopup(false)}
                                            config={{
                                                fullScreen: false,
                                                scrollable: true,
                                                noPadding: true,
                                                topGradient: false,
                                                style: {
                                                    height: '625px',
                                                    width: '800px',
                                                },
                                            }}
                                        >
                                            <PtsWidget
                                                widgetLink={section.secondaryctalink}
                                            />
                                        </Popup>
                                    )}
                                </React.Fragment>

                            )}
                        </div>

                        {!!(section.casestudytitle || section.casestudydescription || section.casestudyauthor) &&
                            <div className={styles.divider} />}
                        {section.casestudytitle && section.casestudylink && (
                            <a href={section.casestudylink} target="_blank" rel="noopener noreferrer">
                                <div className={`text-highlight3 text-teal mb16`}>{section.casestudytitle}</div>
                            </a>
                        )}
                        {section.casestudytitle && !section.casestudylink &&
                            <div className={`text-highlight3 text-teal mb16`}>{section.casestudytitle}</div>}
                        {section.casestudydescription &&
                            <div className={`text-dark mb16`}>{section.casestudydescription}</div>}
                        {section.casestudyauthor &&
                            <div className={`text-small`}>{section.casestudyauthor}</div>}
                    </div>
                    <div className={`col-12 col-md-6 ${section.imageposition === 'right' ? 'order-2' : 'order-1'} ${styles.mediaContent}`}>
                        {section.sectionvideo && videoId
                            ? (
                                <React.Fragment>
                                    <YouTube
                                        className="d-none d-sm-block"
                                        videoId={videoId}
                                        opts={videoOpts}
                                    />
                                    <YouTube
                                        className="d-block d-sm-none"
                                        videoId={videoId}
                                        opts={mobileVideoOpts}
                                    />
                                </React.Fragment>
                            )
                            : (
                                <React.Fragment>
                                    <picture className={`${styles.img} d-none d-sm-block`}>
                                        {bgImg(desktopBg)}
                                    </picture>
                                    <picture className={`${styles.img} d-block d-sm-none`}>
                                        {bgImg(mobileBg)}
                                    </picture>
                                </React.Fragment>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TiledSection;
